angular.module('wbDashboard').controller('PlansDetailFeatureSecurityselectionControllerAurea', ['$scope', '$uibModal', '$filter', 'PlanService', 'Message', function ($scope, $uibModal, $filter, PlanService, Message) {
    var assetInit = false;
    $scope.assetClassesCopy = [];

    $scope.localData.assetsEditable = false;

    $scope.$watch('assetClasses', function(assetClasses) {
        if (assetClasses) {
            //want to work with a copy in case it's changed but not saved
            angular.copy($scope.assetClasses, $scope.assetClassesCopy);
            assetInit = true;
        }
    }, true);

    $scope.toggleEditable = function () {
        $scope.localData.assetsEditable = !$scope.localData.assetsEditable;
        if (!$scope.localData.assetsEditable) {
            //was canceled, reset to defaults
            angular.copy($scope.assetClasses, $scope.assetClassesCopy);
        }
    };

    /**
     * Pause an asset
     * for manual clicking of elements
     * @param assetClass
     * @param asset
     */
    $scope.pauseAsset = function(assetClass, asset) {
        if (assetsEnabled(assetClass.assets).length == 1) {
            Message.set({
                text: "One security must remain active per asset class.",
                type: "warning",
                key: "securityselection"
            });
            return;
        }
        asset.enabled = false;
    };

    /**
     * Activate an asset
     * for manual clicking of elements
     * @param assetClass
     * @param asset
     */
    $scope.activateAsset = function(assetClass, asset) {
        if (assetsEnabled(assetClass.assets).length == 2) {
            Message.set({
                text: "Two securities, at most, can be active per asset class.",
                type: "warning",
                key: "securityselection"
            });
            return;
        }
        asset.enabled = true;
    };

    $scope.resetAssets = function() {
        $scope.pageData.sending = true;
        PlanService.user.getSelectiveAssetsDefaults().then(function(assetClasses) {
             angular.copy(assetClasses, $scope.assetClassesCopy);

        }).catch(function(response) {
            Message.set({
                text: "Sorry, we were unable to retrieve default assets, please try again later.",
                type: "warning",
                key: "securityselection"
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.saveAssets = function() {
        $scope.pageData.sending = true;

        var data = {};

        angular.forEach($scope.assetClassesCopy, function(ac) {
            var active = assetsEnabled(ac.assets);
            data[ac.code] = active.map(function(asset) { return asset.ticker; });
        });

        PlanService.user.saveSelectiveAssets(data).then(function(assetClasses) {
            //angular.copy with an existing array will clear and fill it so it maintains the same reference
            angular.copy(assetClasses, $scope.assetClasses);
            Message.set({
                text: "Your ETFs will update in one business day.",
                type: 'success',
                key: 'securityselection'
            });
            $scope.localData.assetsEditable = false;
        }).catch(function(response) {
            Message.set({
                text: "Sorry, there was a problem saving your " + $scope.feature.display_name + " settings.",
                type: 'danger',
                key: 'securityselection',
                timeout: 99999
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.assetsChanged = function() {
        return !angular.equals($scope.assetClasses, $scope.assetClassesCopy);
    };

    $scope.assetsEnabled = assetsEnabled;
    function assetsEnabled(assets) {
        return $filter('filter')(assets, {enabled: true});
    }

    $scope.whOn = PlanService.getPlanFeature('taxplan', 'wiseharvesting').enabled;

    $scope.toggleFeature.onMessage = false;
    $scope.toggleFeature.offMessage = "Default ETFs will resume trading in one business day.";
    $scope.toggleFeature.complete = function(feature, status) {
        if (!status) {
            //just in case
            $scope.localData.assetsEditable = false;
            //turned off, so update it since it changes after off
            PlanService.user.getSelectiveAssets().then(function (assetClasses) {
                angular.copy(assetClasses, $scope.assetClasses);
                $scope.assetClassesCopy = angular.copy(assetClasses);
            });
        }
    };
}]);
